// extracted by mini-css-extract-plugin
module.exports = {"error":"ISBN_error__3IihZ","helper":"ISBN_helper__2AU7W","buttons":"ISBN_buttons__2XPUw","form":"ISBN_form__1SjYE"};